import * as Handlebars from 'handlebars/dist/handlebars.js';
import * as gfunctions from '../../../js/generalFunctions';
/* eslint-disable */
CCL.editCartStateroom = {
    autoload: [
        ['createStateroomHtml', $('.c-cart-cards').length > 0],
        ['allClickEvents', $('.c-cart').length > 0]
    ],

    createStateroomHtml() {
        if ($('body').find('.cart-edit-stateroom-wrap').length) {
            $('body').find('.cart-edit-stateroom-wrap').each((i, element) => {
                this.ajaxForInitialData(element.dataset.productid, false, [], element.dataset.wishlist2entry, element.dataset.servicetimeslot, element.dataset.buyerid);
            });
        }

    },

    stateroomSelected: 0,

    ajaxForInitialData(productId, orderSummaryRequired = false, bookingIdsArray = [], wishList2Entry = false, serviceTimeSlot = null, buyerId = null) {
        const token = $('#csrfSessionToken').data('csrf');

       const dataObj = {
            productCode: productId,
            cartPage: true,
            orderSummaryRequired,
            wishList2Entry,
            serviceTimeSlot,
            buyerId
        };
        let ajaxUrl = '';
        let ajaxType = '';
        if (window.location.hostname === 'localhost' || window.location.port === '6565') {
            ajaxUrl = `/_ui/responsive/ccl/assets/templates/cart-edit-stateroom/cart-edit-stateroom.json`;
            ajaxType = 'GET';
        } else {
            ajaxUrl = '/shop/cart/clp/modal';
            ajaxType = 'POST';
        }

        $.ajax({
            type: ajaxType,
            contentType: 'application/json',
            url: ajaxUrl,
            data: JSON.stringify(dataObj),
            headers: {
                CSRFToken: token
            }
        }).done((res) => {
            const { orderSummary } = res;
            this.ajaxForRepaintHtml(res, productId, serviceTimeSlot, buyerId);
            if (orderSummaryRequired) {
                const cartQtyClass = serviceTimeSlot ? `.cart-product-qty-${productId}-${serviceTimeSlot}-${buyerId}` : `.cart-product-qty-${productId}`;
                if ($(cartQtyClass).length && bookingIdsArray.length) {
                    $(cartQtyClass)[0].innerText = bookingIdsArray.length;
                    gfunctions.updateCartSummary(orderSummary);
                    gfunctions.updateProductSummary(orderSummary);
                    gfunctions.updateCouponSummary(res);
                }
            }
        }).fail(() => {
            gfunctions.hideLoader();
            console.log('error Occured');
        });
    },

    ajaxForRepaintHtml(data, productId, serviceTimeSlot = null, buyerId = null) {
        let ajaxUrl = '/_ui/responsive/ccl/assets/templates/cart-edit-stateroom/cart-edit-stateroom.html';
        if (data.productCard.productType === 'XD' && serviceTimeSlot) {
            ajaxUrl = '/_ui/responsive/ccl/assets/templates/cart-edit-stateroom/xdining-cart-edit-stateroom.html';
        }
        $.ajax({
            type: 'GET',
            url: ajaxUrl
        }).done((response) => {
            if ($(`#cost-text-${productId}`).length) {
                data.costText = $(`#cost-text-${productId}`).html()
            }
            if ($(`#beverage-condition-${productId}`).length) {
                data.beverageConditionText = $(`#beverage-condition-${productId} .content`).html();
            }
            const templateScript = Handlebars.compile(response);
            const html = templateScript(data);
            if (data.productCard.productType === 'XD' && serviceTimeSlot && buyerId) {
                $(`#cart-edit-${productId}-${serviceTimeSlot}-${buyerId}`).empty().append(html);
                if ($(`.card-${productId}-${serviceTimeSlot}-${buyerId}`).find('.global-red-text.xdining-unavailable').length) {
                    $(`#cart-edit-${productId}-${serviceTimeSlot}-${buyerId}`).find('.selection-btn').removeAttr('disabled')
                }
            } else {
                $(`#cart-edit-${productId}`).empty().append(html);
            }

            gfunctions.pdpGetSelectedData();
            gfunctions.checkboxCheck();
            this.disableMoveToCart();
            gfunctions.hideLoader();
        }).fail(() => {
            gfunctions.hideLoader();
            console.log('error Occured');
        });
    },

    disableMoveToCart() {
        $('#saveForLaterCartSection').find('.c-cart-card').each((index, element) => {

            if ($(element).find('.custom-checkbox .parent-check').length) {
                const stateRoomCheckLength = $(element).find('.custom-checkbox .parent-check:checked').not(':disabled').length;

                if (stateRoomCheckLength < 1) {
                    $(element).find('.moveToCart_FunShop').attr('disabled', 'disabled');
                } else {
                    $(element).find('.moveToCart_FunShop').removeAttr('disabled');
                }
            }
            else if ($(element).find('.c-edit-guest-time-shorex-cart').length) {
                const guestIds = $(element).find('.custom-checkbox').length;
                const checkedGuestLength = $(element).find('.custom-checkbox input:checked').length;
                const conflictingGuestIds = $(element).find('.div-disabled').length;

                if (guestIds === conflictingGuestIds || checkedGuestLength < 1) {
                    $(element).find('.moveToCart_ShoreEx').attr('disabled', 'disabled');
                } else {
                    $(element).find('.moveToCart_ShoreEx').removeAttr('disabled');
                }
            }

        });
    },

    removeProduct(entryId, productId, BBparentProductCode, ajaxUrl, ajaxType, sfDataObj, producttype = null, serviceTimeSlot = null, selectedServiceTimeSlot = null, buyerId = null, selectedBuyerId = null, wheelChairRequired = null) {
        const token = $('#csrfSessionToken').data('csrf');
        const bookingIdsArray = [];
        const guestIdsArray = [];
        const cardId = producttype == 'XD' && serviceTimeSlot ? `#cart-edit-${productId}-${serviceTimeSlot}-${buyerId}` : `#cart-edit-${productId}`;
        $(`${cardId} .custom-checkbox input[type="checkbox"]:checked`).each((index, element) => {
            if (element.hasAttribute('data-bookingid')) {
                bookingIdsArray.push(element.getAttribute('data-bookingid'));
            }
        });

        if ($(`${cardId} .custom-checkbox .guests-check input[type="checkbox"]`).length) {
            $(`${cardId} .custom-checkbox .guests-check input[type="checkbox"]:checked`).each((i, elem) => {
                if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled')) {
                    guestIdsArray.push(elem.getAttribute('data-guestid'));
                }
            });
        }

        const removeObj = {
            productId: entryId
        };

        if (producttype == 'XD' && serviceTimeSlot) {
            removeObj.serviceTimeSlot = serviceTimeSlot;
            removeObj.buyerId = buyerId;
        }
        $.ajax({
            type: 'POST',
            url: '/shop/cart/entry/execute-action/REMOVE',
            contentType: 'application/json',
            headers: {
                CSRFToken: token
            },
            data: JSON.stringify(removeObj)
        }).done((response) => {
            // If booking arrays is empty that means user did not select any stateroom
            // and we now we need to actually remove that product from cart
            if (bookingIdsArray.length) {
                this.addProduct(productId, BBparentProductCode, ajaxUrl, ajaxType, bookingIdsArray, guestIdsArray, sfDataObj, producttype, serviceTimeSlot, selectedServiceTimeSlot, buyerId, selectedBuyerId, wheelChairRequired);
            } else {
                CCL.removeFromCart.updateCart(response, productId);
                this.createStateroomHtml();
            }
            gfunctions.hideLoader();
        }).fail(() => {
            gfunctions.hideLoader();
            console.log('Remove from cart error');
        });
    },

    addProduct(productId, BBparentProductCode, ajaxUrl, ajaxType, bookingIdsArray, guestIdsArray, sfDataObj, producttype = null, serviceTimeSlot = null, selectedServiceTimeSlot = null, buyerId = null, selectedBuyerId = null, wheelChairRequired = null) {
        const token = $('#csrfSessionToken').data('csrf');
        let prodCode = '';
        let dataObj = {};
        if (BBparentProductCode !== '') {
            prodCode = BBparentProductCode;
        } else {
            prodCode = productId;
        }
        if (!jQuery.isEmptyObject(sfDataObj)) {
            dataObj = sfDataObj;
        } else if (producttype == 'XD' && serviceTimeSlot && selectedServiceTimeSlot && selectedBuyerId) {

            const parentElement = $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdining-cart-edit-stateroom-wrap`);
            const childAnonymousGuests = parentElement.find('.child-quantity-input').val();
            const adultAnonymousGuests = parentElement.find('.adult-quantity-input').val();
            const wheelChair = parentElement.find('.js-wheelchair-cartEdit').is(':checked');

          dataObj = JSON.stringify({
                productId,
                bookingIds: bookingIdsArray,
                guestIds: guestIdsArray,
                timeSlot: selectedServiceTimeSlot,
                buyerId: selectedBuyerId,
                isCartPage: 'true',
                childAnonymousGuests,
                adultAnonymousGuests,
                wheelChairRequired: wheelChair
            });
        } else
            dataObj = {
                productCodePost: prodCode,
                CSRFToken: token,
                qty: 1,
                bookingIds: bookingIdsArray,
                guestIds: guestIdsArray,
                wheelChairRequired
            };
        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            contentType: ajaxType,
            data: dataObj,
            headers: {
                CSRFToken: token
            }
        }).done((response) => {

            if (producttype == 'XD' && serviceTimeSlot && selectedServiceTimeSlot && selectedBuyerId) {
                this.updateXdiningProductTile(prodCode, serviceTimeSlot, selectedServiceTimeSlot, response, buyerId, selectedBuyerId);

                // Update ShoreExProducts for any conflicts with xdining
                $('.cart-entries').find('.c-cart-card').each((index, element) => {
                    if ($(element).find('.cancelEditGuest_ShoreEx').length) {
                        $(element).find('.cancelEditGuest_ShoreEx').trigger('click');
                    }
                });
            }

            this.ajaxForInitialData(productId, true, bookingIdsArray, false, selectedServiceTimeSlot, selectedBuyerId);

            const carId = producttype == 'XD' && selectedServiceTimeSlot && selectedBuyerId ? `.c-cart-card.card-${productId}-${selectedServiceTimeSlot}-${selectedBuyerId}` : `.c-cart-card.card-${productId}`;

            const $imgArrowIcon = $(carId).find('.cart-edit-stateroom-link');
            $imgArrowIcon.removeClass('open');
            const parentElement1 = $(carId).find('.cart-edit-stateroom-wrap');
            $(parentElement1).slideToggle();

            gfunctions.hideLoader();
            // Update All products again once one product is removed
            CCL.saveForLaterObj.loadSaveForLaterCartSection();
            // Below is commented to conflict of spa n shoreEx on save for later
            // this.createStateroomHtml();
        }).fail(() => {
            gfunctions.hideLoader();
            console.log('Add from cart error');
        });

    },

    updateXdiningProductTile(prodCode, serviceTimeSlot, selectedServiceTimeSlot, response, buyerId, selectedBuyerId) {
        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdining-cart-edit-stateroom-wrap`)[0].dataset.servicetimeslot = selectedServiceTimeSlot;

        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdining-cart-edit-stateroom-wrap`)[0].dataset.buyerid = selectedBuyerId;

        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId}`).find('.global-red-text.xdining-unavailable').remove();

        // Update the cart alert message also and remove this product from alert msg
        $(`.cart-updates #cart-alert-${prodCode}-${serviceTimeSlot}-${buyerId}`).remove();
        const msgLength = $('.cart-updates .unavailable-item').length;
        $('.cart-updates .available').html(`${msgLength} item(s) in your cart has a conflict that needs to be resolved before you can proceed to checkout.`);

        if (msgLength === 0) {
            $('.cart-updates').remove();
        }

        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdiningDate span`).removeClass('strikeout-text').html(response.xDiningDate);
        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdiningTime span`).removeClass('strikeout-text').html(response.xDiningTime);

        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdiningDate`).attr('aria-label', response.xDiningDate);
        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdiningTime`).attr('aria-label', response.xDiningTime);

        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdining-remove`)[0].dataset.servicetimeslot = selectedServiceTimeSlot;

        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdining-remove`)[0].dataset.buyerid = selectedBuyerId;

        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .xdining-cart-edit-stateroom-wrap`)[0].id = `cart-edit-${prodCode}-${selectedServiceTimeSlot}-${selectedBuyerId}`;


        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId} .cart-product-qty-${prodCode}-${serviceTimeSlot}-${buyerId}`).removeClass(`cart-product-qty-${prodCode}-${serviceTimeSlot}`).addClass(`cart-product-qty-${prodCode}-${selectedServiceTimeSlot}-${selectedBuyerId}`);

        $(`.card-${prodCode}-${serviceTimeSlot}-${buyerId}`).removeClass(`card-${prodCode}-${serviceTimeSlot}-${buyerId}`).addClass(`card-${prodCode}-${selectedServiceTimeSlot}-${selectedBuyerId}`);

        // if user selected same timeslot then merge products and remove one extra card from cart
        if ($(`.card-${prodCode}-${selectedServiceTimeSlot}-${selectedBuyerId}`).length > 1) {
            $($(`.card-${prodCode}-${selectedServiceTimeSlot}-${selectedBuyerId}`)[1]).remove();
        }

    },

    allClickEvents() {
        $('body').on('click', '#saveForLaterCartSection .custom-checkbox .custom-control-input', (event) => {
            this.disableMoveToCart();
        });

        $('body').on('click', '.saveEditCartStateroom', (event) => {
            gfunctions.showLoader();
            const parentElement = $(event.currentTarget).parents('.cart-edit-stateroom-wrap');
            const entryId = parentElement.data('entryid');
            const productId = parentElement[0].dataset.productid;
            const serviceTimeSlot = parentElement[0].dataset.servicetimeslot;
            const wheelChairRequired = $(event.target).closest('.cart-edit-stateroom').find('.js-wheelchair-cartEdit').is(':checked');

            const selectedServiceTimeSlot = $(parentElement).find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot');

            const buyerId = parentElement[0].dataset.buyerid;
            let selectedBuyerId = null;
            if ($(event.currentTarget).parents('.cart-edit-stateroom-wrap').find('.selected-buyer-id').length) {
                selectedBuyerId = $(event.currentTarget).parents('.cart-edit-stateroom-wrap').find('.selected-buyer-id')[0].dataset.selectedbuyerid;
            }

            const producttype = parentElement[0].dataset.producttype;
            let BBparentProductCode = '';
            let ajaxUrl = '';
            let sfDataObj = {};
            let ajaxType = '';
            let current = $(event.currentTarget);
            $(event.currentTarget).parents('.cart-card-body').find('.cart-edit-stateroom-link').attr('aria-expanded', 'false');
            if (parentElement[0].dataset.isbb === 'true') {
                BBparentProductCode = parentElement[0].dataset.parentcode;
            }
            if ((producttype !== '' || producttype !== null) && (producttype === 'SFP' || producttype === 'SF' || producttype === 'SFAP')) {
                ajaxUrl = '/shop/cart/specialFS/add';
                ajaxType = 'application/json';
                if (producttype === 'SFP') {
                    sfDataObj = CCL.pdpSfPackage.bookingData(productId, event, current);
                } else {
                    CCL.termsAndConditions.quantitySet(productId, event, current);
                    sfDataObj = sessionStorage.getItem('sessionTemplateObj');
                }
            } else if ((producttype !== '' || producttype !== null) && (producttype === 'XD') && serviceTimeSlot) {
                ajaxUrl = '/shop/cart/xDining/add';
                ajaxType = 'application/json';
            } else {
                ajaxUrl = '/shop/cart/add';
                ajaxType = 'application/x-www-form-urlencoded; charset=UTF-8';
            }
            this.removeProduct(entryId, productId, BBparentProductCode, ajaxUrl, ajaxType, sfDataObj, producttype, serviceTimeSlot, selectedServiceTimeSlot, buyerId, selectedBuyerId, wheelChairRequired);
            setTimeout(() => {
                parentElement.siblings('.cart-edit-stateroom-link').focus();
                parentElement.siblings('.cart-edit-stateroom-link').addClass('ada-element-focus');
            }, 700);
        });

        $('body').on('click', '.cancelEditCartStateroom', (event) => {
            gfunctions.showLoader();
            const parentElement = $(event.currentTarget).parents('.cart-edit-stateroom-wrap');
            const productId = parentElement[0].dataset.productid;
            const serviceTimeSlot = parentElement[0].dataset.servicetimeslot;
            const buyerId = parentElement[0].dataset.buyerid;
            this.ajaxForInitialData(productId, false, [], parentElement[0].dataset.wishlist2entry, serviceTimeSlot, buyerId);

            const id = serviceTimeSlot && buyerId ? `${productId}-${serviceTimeSlot}-${buyerId}` : productId;

            $(event.currentTarget).parents('.cart-card-body').find('.cart-edit-stateroom-link').attr('aria-expanded', 'false');
            const $imgArrowIcon = $(`.c-cart-card.card-${id}`).find('.cart-edit-stateroom-link');
            $imgArrowIcon.removeClass('open');
            const parentElement1 = $(`.c-cart-card.card-${id}`).find('.cart-edit-stateroom-wrap');
            $(parentElement1).slideToggle();
            setTimeout(() => {
                parentElement.siblings('.cart-edit-stateroom-link').focus();
                parentElement.siblings('.cart-edit-stateroom-link').addClass('ada-element-focus');
            }, 700);
        });

        $('body').on('change', '.js-wheelchair-cartEdit', (e) => {
          const selectDateTime = $(e.target).closest('.cart-edit-stateroom').find('.selected-buyer-id');
          if (!$(e.target).closest('.cart-edit-stateroom').find('.day-time-wrap').is(':visible')){
            if (selectDateTime.prop('disabled')) {
              selectDateTime.prop('disabled', false);
            }
          }
        });
    }
};




// WEBPACK FOOTER //
// ./src/app/components/c-cart-edit-stateroom/cart-edit-stateroom.js